import React, { forwardRef, SVGProps } from 'react';

export const NewStudySpriteSVG = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns='http://www.w3.org/2000/svg'>
    <symbol id='newStudy-video_call' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_723)'>
        <path
          d='M11.6875 5.50781C11.6875 6.05482 11.9048 6.57943 12.2916 6.96622C12.6784 7.35301 13.203 7.57031 13.75 7.57031C14.297 7.57031 14.8216 7.35301 15.2084 6.96622C15.5952 6.57943 15.8125 6.05482 15.8125 5.50781C15.8125 4.9608 15.5952 4.4362 15.2084 4.0494C14.8216 3.66261 14.297 3.44531 13.75 3.44531C13.203 3.44531 12.6784 3.66261 12.2916 4.0494C11.9048 4.4362 11.6875 4.9608 11.6875 5.50781Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.75 8.25781C14.6617 8.25781 15.536 8.61998 16.1807 9.26463C16.8253 9.90929 17.1875 10.7836 17.1875 11.6953'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2.0625 4.13281V2.07031C2.0625 1.70564 2.20737 1.3559 2.46523 1.09804C2.72309 0.840178 3.07283 0.695313 3.4375 0.695312H19.9375C20.3022 0.695313 20.6519 0.840178 20.9098 1.09804C21.1676 1.3559 21.3125 1.70564 21.3125 2.07031V13.0703C21.3125 13.435 21.1676 13.7847 20.9098 14.0426C20.6519 14.3004 20.3022 14.4453 19.9375 14.4453H13.0625'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.8125 14.4453V17.1953'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.4375 17.1953H17.875'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M0.6875 21.3203C0.6875 19.6793 1.3394 18.1055 2.49978 16.9451C3.66016 15.7847 5.23397 15.1328 6.875 15.1328C8.51603 15.1328 10.0898 15.7847 11.2502 16.9451C12.4106 18.1055 13.0625 19.6793 13.0625 21.3203'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.09375 9.97656C3.09375 10.9794 3.49213 11.9412 4.20125 12.6503C4.91037 13.3594 5.87215 13.7578 6.875 13.7578C7.87785 13.7578 8.83963 13.3594 9.54875 12.6503C10.2579 11.9412 10.6563 10.9794 10.6563 9.97656C10.6563 8.97371 10.2579 8.01194 9.54875 7.30281C8.83963 6.59369 7.87785 6.19531 6.875 6.19531C5.87215 6.19531 4.91037 6.59369 4.20125 7.30281C3.49213 8.01194 3.09375 8.97371 3.09375 9.97656Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_723'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id='newStudy-focus_groups' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_366)'>
        <path
          d='M1.71783 16.1563C1.71783 16.7944 1.97135 17.4065 2.42261 17.8577C2.87387 18.309 3.48591 18.5625 4.12408 18.5625C4.76226 18.5625 5.3743 18.309 5.82556 17.8577C6.27682 17.4065 6.53033 16.7944 6.53033 16.1563C6.53033 15.5181 6.27682 14.906 5.82556 14.4548C5.3743 14.0035 4.76226 13.75 4.12408 13.75C3.48591 13.75 2.87387 14.0035 2.42261 14.4548C1.97135 14.906 1.71783 15.5181 1.71783 16.1563Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.56158 21.3125C7.2293 20.6895 6.73395 20.1685 6.12847 19.8052C5.523 19.4419 4.83018 19.25 4.12408 19.25C3.41799 19.25 2.72517 19.4419 2.11969 19.8052C1.51422 20.1685 1.01887 20.6895 0.686584 21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.4678 16.1563C15.4678 16.4722 15.5301 16.7851 15.651 17.0771C15.7719 17.369 15.9492 17.6343 16.1726 17.8577C16.396 18.0812 16.6613 18.2584 16.9533 18.3793C17.2452 18.5003 17.5581 18.5625 17.8741 18.5625C18.1901 18.5625 18.503 18.5003 18.7949 18.3793C19.0869 18.2584 19.3521 18.0812 19.5756 17.8577C19.799 17.6343 19.9762 17.369 20.0972 17.0771C20.2181 16.7851 20.2803 16.4722 20.2803 16.1563C20.2803 15.8403 20.2181 15.5274 20.0972 15.2354C19.9762 14.9435 19.799 14.6782 19.5756 14.4548C19.3521 14.2313 19.0869 14.0541 18.7949 13.9332C18.503 13.8122 18.1901 13.75 17.8741 13.75C17.5581 13.75 17.2452 13.8122 16.9533 13.9332C16.6613 14.0541 16.396 14.2313 16.1726 14.4548C15.9492 14.6782 15.7719 14.9435 15.651 15.2354C15.5301 15.5274 15.4678 15.8403 15.4678 16.1563Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M21.3116 21.3125C20.9793 20.6895 20.4839 20.1685 19.8785 19.8052C19.273 19.4419 18.5802 19.25 17.8741 19.25C17.168 19.25 16.4752 19.4419 15.8697 19.8052C15.2642 20.1685 14.7689 20.6895 14.4366 21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.59283 3.09375C8.59283 3.40974 8.65507 3.72264 8.776 4.01458C8.89693 4.30652 9.07417 4.57178 9.29761 4.79523C9.52105 5.01867 9.78631 5.19591 10.0783 5.31684C10.3702 5.43776 10.6831 5.5 10.9991 5.5C11.3151 5.5 11.628 5.43776 11.9199 5.31684C12.2119 5.19591 12.4771 5.01867 12.7006 4.79523C12.924 4.57178 13.1012 4.30652 13.2222 4.01458C13.3431 3.72264 13.4053 3.40974 13.4053 3.09375C13.4053 2.77776 13.3431 2.46486 13.2222 2.17292C13.1012 1.88098 12.924 1.61572 12.7006 1.39227C12.4771 1.16883 12.2119 0.99159 11.9199 0.870665C11.628 0.749739 11.3151 0.6875 10.9991 0.6875C10.6831 0.6875 10.3702 0.749739 10.0783 0.870665C9.78631 0.99159 9.52105 1.16883 9.29761 1.39227C9.07417 1.61572 8.89693 1.88098 8.776 2.17292C8.65507 2.46486 8.59283 2.77776 8.59283 3.09375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.9773 7.56249C13.61 7.13116 13.1533 6.78474 12.639 6.54718C12.1246 6.30962 11.5648 6.18658 10.9982 6.18658C10.4316 6.18658 9.87178 6.30962 9.3574 6.54718C8.84303 6.78474 8.38638 7.13116 8.01901 7.56249'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.29584 18.0647C10.0515 18.7341 11.993 18.7282 13.7445 18.0482'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.819 5.5C5.06645 6.20482 4.46662 7.05664 4.05666 8.00271C3.6467 8.94877 3.43534 9.96893 3.43567 11C3.43567 11.2319 3.44942 11.4583 3.4705 11.6875'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.5268 11.6875C18.5469 11.4602 18.5616 11.2292 18.5616 11C18.5621 9.96891 18.3508 8.9487 17.9408 8.00261C17.5309 7.05652 16.9309 6.20472 16.1783 5.5'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_366'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-round_robin' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_800)'>
        <path
          d='M16.7994 11C16.7994 10.8291 16.7315 10.6652 16.6106 10.5444C16.4898 10.4235 16.3259 10.3556 16.155 10.3556H5.845C5.6741 10.3556 5.5102 10.4235 5.38936 10.5444C5.26851 10.6652 5.20062 10.8291 5.20062 11'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2.30093 15.8328C2.30093 16.129 2.35927 16.4223 2.47261 16.6959C2.58595 16.9695 2.75207 17.2181 2.9615 17.4276C3.17092 17.637 3.41955 17.8031 3.69318 17.9165C3.9668 18.0298 4.26007 18.0881 4.55625 18.0881C4.85242 18.0881 5.14569 18.0298 5.41932 17.9165C5.69294 17.8031 5.94157 17.637 6.15099 17.4276C6.36042 17.2181 6.52654 16.9695 6.63988 16.6959C6.75322 16.4223 6.81156 16.129 6.81156 15.8328C6.81156 15.2347 6.57395 14.661 6.15099 14.2381C5.72804 13.8151 5.15439 13.5775 4.55625 13.5775C3.9581 13.5775 3.38445 13.8151 2.9615 14.2381C2.53855 14.661 2.30093 15.2347 2.30093 15.8328Z'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.77813 20.6656C7.46669 20.0817 7.00241 19.5934 6.43492 19.2529C5.86742 18.9124 5.21806 18.7325 4.55626 18.7325C3.89445 18.7325 3.24509 18.9124 2.6776 19.2529C2.1101 19.5934 1.64582 20.0817 1.33438 20.6656'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.1884 15.8328C15.1884 16.129 15.2468 16.4223 15.3601 16.6959C15.4735 16.9695 15.6396 17.2181 15.849 17.4276C16.0584 17.637 16.3071 17.8031 16.5807 17.9165C16.8543 18.0298 17.1476 18.0881 17.4438 18.0881C17.7399 18.0881 18.0332 18.0298 18.3068 17.9165C18.5805 17.8031 18.8291 17.637 19.0385 17.4276C19.2479 17.2181 19.4141 16.9695 19.5274 16.6959C19.6407 16.4223 19.6991 16.129 19.6991 15.8328C19.6991 15.2347 19.4615 14.661 19.0385 14.2381C18.6156 13.8151 18.0419 13.5775 17.4438 13.5775C16.8456 13.5775 16.272 13.8151 15.849 14.2381C15.4261 14.661 15.1884 15.2347 15.1884 15.8328Z'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.6656 20.6656C20.3542 20.0817 19.8899 19.5934 19.3224 19.2529C18.7549 18.9124 18.1055 18.7325 17.4437 18.7325C16.7819 18.7325 16.1326 18.9124 15.5651 19.2529C14.9976 19.5934 14.5333 20.0817 14.2219 20.6656'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.74469 3.58969C8.74469 3.88587 8.80303 4.17914 8.91637 4.45276C9.02971 4.72639 9.19583 4.97502 9.40526 5.18444C9.61468 5.39387 9.8633 5.55999 10.1369 5.67333C10.4106 5.78667 10.7038 5.84501 11 5.84501C11.2962 5.84501 11.5894 5.78667 11.8631 5.67333C12.1367 5.55999 12.3853 5.39387 12.5947 5.18444C12.8042 4.97502 12.9703 4.72639 13.0836 4.45276C13.197 4.17914 13.2553 3.88587 13.2553 3.58969C13.2553 3.29352 13.197 3.00025 13.0836 2.72662C12.9703 2.453 12.8042 2.20437 12.5947 1.99495C12.3853 1.78552 12.1367 1.6194 11.8631 1.50606C11.5894 1.39272 11.2962 1.33438 11 1.33438C10.7038 1.33438 10.4106 1.39272 10.1369 1.50606C9.8633 1.6194 9.61468 1.78552 9.40526 1.99495C9.19583 2.20437 9.02971 2.453 8.91637 2.72662C8.80303 3.00025 8.74469 3.29352 8.74469 3.58969Z'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.7914 7.77813C13.4471 7.37385 13.0191 7.04916 12.537 6.8265C12.0549 6.60384 11.5302 6.48853 10.9991 6.48853C10.4681 6.48853 9.94339 6.60384 9.46129 6.8265C8.97918 7.04916 8.55117 7.37385 8.20685 7.77813'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_800'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-collective' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_814)'>
        <path
          d='M9.06944 9.09264C8.28242 8.65079 7.39452 8.41994 6.49194 8.42249C5.2294 8.41259 4.00713 8.86638 3.05694 9.6978C2.10675 10.5292 1.49473 11.6804 1.33694 12.9331'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.58969 4.23407C3.58969 5.00311 3.89519 5.74066 4.43899 6.28446C4.98279 6.82825 5.72033 7.13376 6.48938 7.13376C7.25842 7.13376 7.99597 6.82825 8.53977 6.28446C9.08356 5.74066 9.38907 5.00311 9.38907 4.23407C9.38907 3.85328 9.31406 3.47621 9.16834 3.12441C9.02262 2.7726 8.80903 2.45294 8.53977 2.18368C8.27051 1.91442 7.95085 1.70083 7.59904 1.55511C7.24723 1.40938 6.87017 1.33438 6.48938 1.33438C6.10859 1.33438 5.73152 1.40938 5.37972 1.55511C5.02791 1.70083 4.70825 1.91442 4.43899 2.18368C4.16973 2.45294 3.95614 2.7726 3.81042 3.12441C3.66469 3.47621 3.58969 3.85328 3.58969 4.23407Z'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.6109 3.58969C12.6109 4.18784 12.8485 4.76149 13.2715 5.18444C13.6944 5.60739 14.2681 5.84501 14.8662 5.84501C15.4644 5.84501 16.038 5.60739 16.461 5.18444C16.8839 4.76149 17.1216 4.18784 17.1216 3.58969C17.1216 2.99155 16.8839 2.4179 16.461 1.99495C16.038 1.57199 15.4644 1.33438 14.8662 1.33438C14.2681 1.33438 13.6944 1.57199 13.2715 1.99495C12.8485 2.4179 12.6109 2.99155 12.6109 3.58969Z'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.217 8.42251C17.9094 7.89024 17.4792 7.43901 16.9623 7.10624C16.4454 6.77348 15.8566 6.56879 15.2447 6.50914C14.6328 6.4495 14.0155 6.53663 13.4441 6.76331C12.8726 6.98998 12.3635 7.34966 11.9588 7.8125'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.6444 10.3556H19.3769C19.3769 10.3556 20.6656 10.3556 20.6656 11.6444V16.7994C20.6656 16.7994 20.6656 18.0881 19.3769 18.0881H11.6444C11.6444 18.0881 10.3556 18.0881 10.3556 16.7994V11.6444C10.3556 11.6444 10.3556 10.3556 11.6444 10.3556Z'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.9331 20.6656H18.0881'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.5106 20.6656V18.0881'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_814'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-continuous' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_836)'>
        <path
          d='M7.77813 15.5106H2.62313C2.28133 15.5106 1.95353 15.3749 1.71185 15.1332C1.47016 14.8915 1.33438 14.5637 1.33438 14.2219V3.91189C1.33438 3.57009 1.47016 3.24229 1.71185 3.0006C1.95353 2.75892 2.28133 2.62314 2.62313 2.62314H14.2219C14.5637 2.62314 14.8915 2.75892 15.1332 3.0006C15.3749 3.24229 15.5106 3.57009 15.5106 3.91189V7.77814'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.33438 6.48938H15.5106'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.20062 3.91188V1.33438'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.6444 3.91188V1.33438'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.5775 16.7994H10.3556V20.0213'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.1647 17.43C19.8229 18.4267 19.1617 19.2828 18.2839 19.8656C17.406 20.4484 16.3604 20.7253 15.3092 20.6535C14.2579 20.5816 13.2597 20.165 12.4693 19.4682C11.6789 18.7714 11.1404 17.8333 10.9373 16.7994'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.4438 14.2219H20.6656V11'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.8565 13.5921C11.1978 12.5948 11.8586 11.7381 12.7365 11.1547C13.6144 10.5714 14.6603 10.2941 15.7119 10.3659C16.7635 10.4376 17.762 10.8544 18.5525 11.5517C19.343 12.2489 19.8814 13.1875 20.084 14.2219'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_836'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-prototype_test' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_540)'>
        <path
          d='M10.0137 4.88675C9.8996 4.83312 9.77426 4.80787 9.64833 4.81314C9.5224 4.8184 9.39961 4.85404 9.29042 4.917C9.18442 4.97701 9.09604 5.0638 9.03411 5.16868C8.97217 5.27356 8.93886 5.39287 8.9375 5.51466V8.92283C8.93895 9.04461 8.97231 9.16388 9.03423 9.26874C9.09615 9.37361 9.18448 9.46041 9.29042 9.5205C9.39961 9.58346 9.5224 9.61909 9.64833 9.62436C9.77426 9.62963 9.8996 9.60437 10.0137 9.55075L13.2119 8.041C13.3718 7.97108 13.5079 7.85607 13.6034 7.71003C13.6989 7.56399 13.7498 7.39326 13.7498 7.21875C13.7498 7.04424 13.6989 6.87351 13.6034 6.72747C13.5079 6.58143 13.3718 6.46641 13.2119 6.3965L10.0137 4.88675Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.4375 20.625H7.5625L8.25 16.5H13.75L14.4375 20.625Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M5.5 20.625H16.5' stroke='white' strokeWidth='1.375' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M0.6875 13.0625H21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.4792 1.375H2.52083C1.50831 1.375 0.6875 2.19581 0.6875 3.20833V14.6667C0.6875 15.6792 1.50831 16.5 2.52083 16.5H19.4792C20.4917 16.5 21.3125 15.6792 21.3125 14.6667V3.20833C21.3125 2.19581 20.4917 1.375 19.4792 1.375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_540'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-unmoderated_test' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_540)'>
        <path
          d='M10.0137 4.88675C9.8996 4.83312 9.77426 4.80787 9.64833 4.81314C9.5224 4.8184 9.39961 4.85404 9.29042 4.917C9.18442 4.97701 9.09604 5.0638 9.03411 5.16868C8.97217 5.27356 8.93886 5.39287 8.9375 5.51466V8.92283C8.93895 9.04461 8.97231 9.16388 9.03423 9.26874C9.09615 9.37361 9.18448 9.46041 9.29042 9.5205C9.39961 9.58346 9.5224 9.61909 9.64833 9.62436C9.77426 9.62963 9.8996 9.60437 10.0137 9.55075L13.2119 8.041C13.3718 7.97108 13.5079 7.85607 13.6034 7.71003C13.6989 7.56399 13.7498 7.39326 13.7498 7.21875C13.7498 7.04424 13.6989 6.87351 13.6034 6.72747C13.5079 6.58143 13.3718 6.46641 13.2119 6.3965L10.0137 4.88675Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.4375 20.625H7.5625L8.25 16.5H13.75L14.4375 20.625Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M5.5 20.625H16.5' stroke='white' strokeWidth='1.375' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M0.6875 13.0625H21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.4792 1.375H2.52083C1.50831 1.375 0.6875 2.19581 0.6875 3.20833V14.6667C0.6875 15.6792 1.50831 16.5 2.52083 16.5H19.4792C20.4917 16.5 21.3125 15.6792 21.3125 14.6667V3.20833C21.3125 2.19581 20.4917 1.375 19.4792 1.375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_540'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-card_sort' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <path
        d='M14.652 1.54733H3.05063C2.82259 1.54733 2.60389 1.63792 2.44264 1.79917C2.28139 1.96042 2.1908 2.17913 2.1908 2.40717V19.5947C2.1908 19.8227 2.28139 20.0414 2.44264 20.2027C2.60389 20.3639 2.82259 20.4545 3.05063 20.4545H14.652C14.88 20.4545 15.0987 20.3639 15.26 20.2027C15.4212 20.0414 15.5118 19.8227 15.5118 19.5947V2.40625C15.5118 2.17821 15.4212 1.95951 15.26 1.79826C15.0987 1.63701 14.88 1.54642 14.652 1.54642V1.54733Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.5118 3.04974L19.1684 4.01408C19.3888 4.07239 19.5769 4.21579 19.6916 4.41277C19.8062 4.60976 19.838 4.8442 19.7798 5.06458L15.8913 19.8128C15.8543 19.9531 15.7824 20.0818 15.6823 20.1868'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M2.19177 16.5871H15.455' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </symbol>

    <symbol id='newStudy-tree_test' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <rect x='2.16' y='2.16' width='19.68' height='4.68' rx='0.84' stroke='white' strokeWidth='1.32' />
      <rect x='8.16' y='9.66' width='13.68' height='4.68' rx='0.84' stroke='white' strokeWidth='1.32' />
      <rect x='8.16' y='17.16' width='13.68' height='4.68' rx='0.84' stroke='white' strokeWidth='1.32' />
      <path d='M8.25 12H3.75V6.75' stroke='white' strokeWidth='1.5' strokeLinejoin='round' />
      <path d='M8.25 12H3.75V6.75' stroke='white' strokeWidth='1.5' strokeLinejoin='round' />
      <path d='M8.25 19.5H3.75V12' stroke='white' strokeWidth='1.5' strokeLinejoin='round' />
    </symbol>

    <symbol id='newStudy-five_second_test' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <path
        d='M15.484 4.29536C18.137 5.84073 19.9201 8.7158 19.9201 12.0073C19.9201 16.933 15.927 20.926 11.0014 20.926C6.07577 20.926 2.08276 16.933 2.08276 12.0073C2.08276 7.08171 6.07577 3.0887 11.0014 3.0887H12.7782'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M11 1.07422L13.0153 3.08949L11 5.10477' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12.336 9.09926H9.66241L9.39502 12.0402L10.0129 11.7313C10.3099 11.5828 10.6374 11.5055 10.9694 11.5055H10.9992C11.8851 11.5055 12.6034 12.2237 12.6034 13.1097V13.9118C12.6034 14.7977 11.8851 15.5159 10.9992 15.5159C10.3007 15.5159 9.6152 15.0695 9.39502 14.4464'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </symbol>

    <symbol id='newStudy-preference_test' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_582)'>
        <path
          d='M5.50014 21.3116L3.75847 18.2627C3.49093 17.7957 3.41536 17.243 3.54774 16.7213C3.68011 16.1997 4.01007 15.7499 4.46791 15.4669C4.92575 15.184 5.47564 15.0901 6.00144 15.205C6.52724 15.3199 6.98778 15.6347 7.28581 16.0829L8.93581 18.5579V8.25C8.93581 7.70299 9.1531 7.17839 9.5399 6.79159C9.92669 6.4048 10.4513 6.1875 10.9983 6.1875C11.5453 6.1875 12.0699 6.4048 12.4567 6.79159C12.8435 7.17839 13.0608 7.70299 13.0608 8.25V15.8125H16.1582C17.1807 15.8619 18.1446 16.3042 18.8488 17.0472C19.553 17.7901 19.9431 18.7763 19.9376 19.8V21.3152'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M16.5 0.685715L21.3125 5.49821' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M16.5 5.49821L21.3125 0.685715' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M6.875 0.685715L3.4375 5.49821L0.6875 2.74821'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_582'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-first_click_test' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_561)'>
        <path
          d='M9.7221 9.26056L10.654 20.7393C10.6568 21.2969 11.3808 21.4138 11.8159 21.0197L14.4526 17.9171L18.5366 17.9266C19.0942 17.9238 19.392 17.2291 19.0739 16.8991L10.9103 8.8025C10.4404 8.26235 9.64336 8.59787 9.7221 9.26056Z'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11 0.74765V4.41431'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.21667 3.58932L6.87501 6.15593'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.375 10.3727H5.04167'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.21667 17.1559L6.87501 14.5893'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.625 10.3727H16.9584'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.875 3.58932L15.2167 6.15593'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_561'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-survey' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_6_1410)'>
        <path
          d='M7.55884 18.5625H2.05884C1.69417 18.5625 1.34443 18.4176 1.08657 18.1598C0.828704 17.9019 0.683838 17.5522 0.683838 17.1875V2.0625C0.683838 1.69783 0.828704 1.34809 1.08657 1.09023C1.34443 0.832366 1.69417 0.6875 2.05884 0.6875H15.8088C16.1735 0.6875 16.5232 0.832366 16.7811 1.09023C17.039 1.34809 17.1838 1.69783 17.1838 2.0625V8.25M7.55884 4.8125H13.0588M4.80884 8.9375H13.0588M4.80884 13.0625H11.6838M20.7414 13.6308L13.75 20.625L10.3125 21.3125L11 17.875L17.9951 10.8808C18.175 10.7006 18.3887 10.5576 18.6239 10.46C18.8591 10.3625 19.1113 10.3123 19.366 10.3123C19.6206 10.3123 19.8728 10.3625 20.108 10.46C20.3432 10.5576 20.5569 10.7006 20.7368 10.8808L20.7451 10.8882C21.1082 11.2524 21.3118 11.7459 21.3112 12.2603C21.3105 12.7746 21.1055 13.2676 20.7414 13.6308Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6_1410'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>

    <symbol id='newStudy-panel' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_524)'>
        <path
          d='M17.875 3.4375V1.375C17.875 1.19266 17.8026 1.0178 17.6736 0.888864C17.5447 0.759933 17.3698 0.6875 17.1875 0.6875H4.8125C4.63016 0.6875 4.4553 0.759933 4.32636 0.888864C4.19743 1.0178 4.125 1.19266 4.125 1.375V3.4375C4.48967 3.4375 4.83941 3.58237 5.09727 3.84023C5.35513 4.09809 5.5 4.44783 5.5 4.8125C5.5 5.17717 5.35513 5.52691 5.09727 5.78477C4.83941 6.04263 4.48967 6.1875 4.125 6.1875V8.25C4.125 8.43234 4.19743 8.6072 4.32636 8.73614C4.4553 8.86507 4.63016 8.9375 4.8125 8.9375H17.1875C17.3698 8.9375 17.5447 8.86507 17.6736 8.73614C17.8026 8.6072 17.875 8.43234 17.875 8.25V6.1875C17.5103 6.1875 17.1606 6.04263 16.9027 5.78477C16.6449 5.52691 16.5 5.17717 16.5 4.8125C16.5 4.44783 16.6449 4.09809 16.9027 3.84023C17.1606 3.58237 17.5103 3.4375 17.875 3.4375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M8.25 3.4375V6.1875' stroke='white' strokeWidth='1.375' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M15.8125 14.4375C15.8125 14.9845 16.0298 15.5091 16.4166 15.8959C16.8034 16.2827 17.328 16.5 17.875 16.5C18.422 16.5 18.9466 16.2827 19.3334 15.8959C19.7202 15.5091 19.9375 14.9845 19.9375 14.4375C19.9375 13.8905 19.7202 13.3659 19.3334 12.9791C18.9466 12.5923 18.422 12.375 17.875 12.375C17.328 12.375 16.8034 12.5923 16.4166 12.9791C16.0298 13.3659 15.8125 13.8905 15.8125 14.4375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.4375 21.3125C14.4375 20.4008 14.7997 19.5265 15.4443 18.8818C16.089 18.2372 16.9633 17.875 17.875 17.875C18.7867 17.875 19.661 18.2372 20.3057 18.8818C20.9503 19.5265 21.3125 20.4008 21.3125 21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.9375 14.4375C8.9375 14.9845 9.1548 15.5091 9.54159 15.8959C9.92839 16.2827 10.453 16.5 11 16.5C11.547 16.5 12.0716 16.2827 12.4584 15.8959C12.8452 15.5091 13.0625 14.9845 13.0625 14.4375C13.0625 13.8905 12.8452 13.3659 12.4584 12.9791C12.0716 12.5923 11.547 12.375 11 12.375C10.453 12.375 9.92839 12.5923 9.54159 12.9791C9.1548 13.3659 8.9375 13.8905 8.9375 14.4375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.5625 21.3125C7.5625 20.4008 7.92466 19.5265 8.56932 18.8818C9.21398 18.2372 10.0883 17.875 11 17.875C11.9117 17.875 12.786 18.2372 13.4307 18.8818C14.0753 19.5265 14.4375 20.4008 14.4375 21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2.0625 14.4375C2.0625 14.9845 2.2798 15.5091 2.66659 15.8959C3.05339 16.2827 3.57799 16.5 4.125 16.5C4.67201 16.5 5.19661 16.2827 5.58341 15.8959C5.9702 15.5091 6.1875 14.9845 6.1875 14.4375C6.1875 13.8905 5.9702 13.3659 5.58341 12.9791C5.19661 12.5923 4.67201 12.375 4.125 12.375C3.57799 12.375 3.05339 12.5923 2.66659 12.9791C2.2798 13.3659 2.0625 13.8905 2.0625 14.4375Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M0.6875 21.3125C0.6875 20.4008 1.04966 19.5265 1.69432 18.8818C2.33898 18.2372 3.21332 17.875 4.125 17.875C5.03668 17.875 5.91102 18.2372 6.55568 18.8818C7.20034 19.5265 7.5625 20.4008 7.5625 21.3125'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_524'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id='newStudy-online_task' width='22' height='22' viewBox='0 0 22 22' fill='none'>
      <g clipPath='url(#clip0_33_790)'>
        <path
          d='M14.9531 7.03906L9.82712 12.1651C9.68622 12.3056 9.49536 12.3845 9.29638 12.3845C9.09739 12.3845 8.90653 12.3056 8.76562 12.1651L7.04688 10.4491'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.5068 15.9425L15.9308 20.5194C15.6753 20.7747 15.372 20.9772 15.0382 21.1153C14.7045 21.2534 14.3468 21.3244 13.9856 21.3242H3.4375C2.70815 21.3242 2.00868 21.0345 1.49296 20.5188C0.977231 20.003 0.6875 19.3036 0.6875 18.5742V3.44922C0.6875 2.71987 0.977231 2.0204 1.49296 1.50468C2.00868 0.98895 2.70815 0.699219 3.4375 0.699219H18.5625C19.2918 0.699219 19.9913 0.98895 20.507 1.50468C21.0228 2.0204 21.3125 2.71987 21.3125 3.44922V13.9982C21.3123 14.7275 21.0225 15.4269 20.5068 15.9425Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.4375 21.2866V17.1992C14.4375 16.4699 14.7272 15.7704 15.243 15.2547C15.7587 14.7389 16.4582 14.4492 17.1875 14.4492H21.2749'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_33_790'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </symbol>
  </svg>
));
